import { render } from "./BulletListWithTwoCheckmarkIcon.vue?vue&type=template&id=802353f0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__